import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminUsersApi, AdminUserCreateRequest, AdminUserUpdateRequest } from '../api/adminUsers';

export const useAdminUserList = () => {
  return useQuery({
    queryKey: ['admin-users'],
    queryFn: () => adminUsersApi.list(),
  });
};

export const useCreateAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AdminUserCreateRequest) => adminUsersApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users'] });
    },
  });
};

export const useUpdateAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, data }: { userId: string; data: AdminUserUpdateRequest }) =>
      adminUsersApi.update(userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users'] });
    },
  });
};

export const useDeleteAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => adminUsersApi.delete(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users'] });
    },
  });
};

export const useResetAdminPassword = () => {
  return useMutation({
    mutationFn: ({ userId, newPassword }: { userId: string; newPassword: string }) =>
      adminUsersApi.resetPassword(userId, newPassword),
  });
};
